/**
 * Wishlist — ΙΕΡΟ συμβόλαιο αποθήκευσης (contract §6β):
 * localStorage key = `items`, τιμή = JSON array από product HANDLES.
 * Format επαληθευμένο εμπειρικά Σ07-08 (injection στη live wishlist page
 * render-άρει σωστά). Αλλαγή key/format = ΟΛΟΙ οι πελάτες χάνουν τα
 * αγαπημένα τους στο go-live — ΑΠΑΓΟΡΕΥΕΤΑΙ.
 */
(function () {
  var KEY = 'items';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) { /* quota/private mode */ }
  }

  function toggle(handle) {
    var items = read();
    var i = items.indexOf(handle);
    if (i === -1) items.push(handle);
    else items.splice(i, 1);
    write(items);
    refresh();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function refresh() {
    var items = read();
    document.querySelectorAll('[data-icon-wishlist][data-product-handle]').forEach(function (btn) {
      var active = items.indexOf(btn.getAttribute('data-product-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-icon-wishlist][data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-product-handle'));
  });

  window.ThemeWishlist = { read: read, toggle: toggle, refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
